import { Link } from "@/i18n/routing";
import { CartCalculations, CartSummary, CurrencySymbol, PromoCode, ToggleSummary } from "@repo/components";
import cx from "classnames";
import { getTranslations } from "next-intl/server";
const CheckoutOrderSummary = async props => {
  const tCommon = await getTranslations("Common");
  const tCart = await getTranslations("Cart");
  const {
    lineItems,
    cartTotal,
    couponName,
    session,
    isAutoApply
  } = props || {};
  return <div className="border-miniCart-checkout-border" data-sentry-component="CheckoutOrderSummary" data-sentry-source-file="CheckoutOrderSummary.jsx">
      <ToggleSummary title={tCommon("Order_Summary")} data-sentry-element="ToggleSummary" data-sentry-source-file="CheckoutOrderSummary.jsx">
        <CartSummary products={lineItems} data-sentry-element="CartSummary" data-sentry-source-file="CheckoutOrderSummary.jsx" />
        <div className="border-miniCart-checkout-border bg-miniCart-checkout-bg border-t">
          {session ? <PromoCode coupon={couponName} session={session} isAutoApply={isAutoApply} /> : <p className="p-4 text-sm">
              {tCommon("Please")}{" "}
              <Link href="/login" className="font-bold">
                {tCommon("Login")}
              </Link>{" "}
              {tCommon("To_Redeem_Your_Coupon")}
            </p>}
        </div>
        <div className={cx("border-miniCart-checkout-border font-heading text-miniCart-text rtl:font-arabic items-center border-t px-3 py-4 text-sm font-medium md:text-2xl")}>
          <span>{tCart("Pricing_Details")}</span>
        </div>
        <CartCalculations summary={cartTotal} couponName={couponName} data-sentry-element="CartCalculations" data-sentry-source-file="CheckoutOrderSummary.jsx" />
      </ToggleSummary>
      <div className="bg-miniCart-checkout-bg flex p-3">
        <div className="text-miniCart-text text-lg font-semibold">
          {tCommon("Total")}
        </div>
        <div className="text-miniCart-text ms-auto text-lg font-semibold">
          <CurrencySymbol value={cartTotal?.formattedTotal} data-sentry-element="CurrencySymbol" data-sentry-source-file="CheckoutOrderSummary.jsx" />
        </div>
      </div>
    </div>;
};
export default CheckoutOrderSummary;